import React, { useState, useEffect } from "react";
import { createComponent } from "@lit-labs/react";
import { DSGlobalMenu, DSSwitch } from "@ds/ds-snam";
import { SidebarDefault } from "@ds/ds-snam/react";
import { IGlobalMenuConfig, IGlobalMenuFirstLevelCategory, IGlobalMenuSecondLevelCategory } from "dataModels/ds-navigation";
import { IAppUserProfile, RoutePath } from "shared/constants";
import { useLocation, useNavigate } from "react-router-dom";
import { setLayoutMode } from "state/reducer/dsLayoutMode";
import { useDispatch } from "react-redux";
import { DsLayout } from "shared/constants";
import { useTranslation } from "react-i18next";
import useAppUser from "hooks/useAppUser";
import { AppUser } from "ooAuth2/appUser";
import { AppUserRole } from "shared/constants";


const ThemeSwitcher = createComponent({
    react: React,
    tagName: "ds-switch",
    elementClass: DSSwitch,
    events: {
        onSwitchChange: "onSwitchChange"
    }
});

const AppSidebar: React.FC<{}> = (props): JSX.Element => {
    const { t } = useTranslation(["app"]);

    const DASHBOARD_MENU_ITEM: IGlobalMenuFirstLevelCategory = {
        firstLevelName: t('sideBar.firstLevelButtons.0', { ns: ['app'] }),//"Dashboard",
        firstLevelIcon: "icon-dashboard-1",
        hasChildren: false,
        url: RoutePath.DASHBOARD,
        ariaLabel: "Dashboard",
        isExternal: false,
        isRouterLink: true
    }

    const getContractMenuItem = ():IGlobalMenuFirstLevelCategory=>{

        const rootElement:IGlobalMenuFirstLevelCategory = {
            firstLevelName: t('sideBar.firstLevelButtons.1.label', { ns: ['app'] }), //"Gestione contratti",
            firstLevelIcon: "icon-notes-1",
            hasChildren: true,
            //url: RoutePath.CONTRACTS,
            ariaLabel: "Contratti",
            isExternal: false,
            isRouterLink: false
        }

        const secondLevel:IGlobalMenuSecondLevelCategory[] = [];
        //CR: Carrier doesn't have customers and contract from submenu
        if(appUserRole !== AppUserRole.CARRIER){
            secondLevel.push({
                secondLevelName: t('sideBar.firstLevelButtons.1.secondLevelButtons.0', { ns: ['app'] }), //"Informazioni anagrafiche",
                hasChildren: false,
                isRouterLink: true,
                url: RoutePath.CONTRACTS_CUSTOMER_INFO,
            },
            {
                secondLevelName: t('sideBar.firstLevelButtons.1.secondLevelButtons.1', { ns: ['app'] }), //"Informazioni contrattuali",
                hasChildren: false,
                isRouterLink: true,
                url: RoutePath.CONTRACTS_CONTRACT_INFO
            });
        }

        secondLevel.push(
            {
                secondLevelName: t('sideBar.firstLevelButtons.1.secondLevelButtons.2', { ns: ['app'] }), //"Flotta autisti",
                hasChildren: false,
                isRouterLink: true,
                url: RoutePath.CONTRACTS_DRIVER_INFO
            },
            {
                secondLevelName: t('sideBar.firstLevelButtons.1.secondLevelButtons.3', { ns: ['app'] }), //"Trasportatori",
                hasChildren: false,
                isRouterLink: true,
                url: RoutePath.CONTRACTS_TRANSPORTATORS_INFO
            },
            {
                secondLevelName: t('sideBar.firstLevelButtons.1.secondLevelButtons.4', { ns: ['app'] }), //"Flotta automezzi",
                hasChildren: false,
                isRouterLink: true,
                url: RoutePath.CONTRACTS_VEHICLE_INFO
            }/*,
            {
                secondLevelName: t('sideBar.firstLevelButtons.1.secondLevelButtons.5', {ns:['app']}), //"Conguaglio",
                hasChildren: false
            }*/
        );
        rootElement.secondLevelCategories = secondLevel;
        return rootElement;

    }

    const getB2bMenuItem = ():IGlobalMenuFirstLevelCategory=>{
        const rootElement:IGlobalMenuFirstLevelCategory = {
            firstLevelName: t('sideBar.firstLevelButtons.2.label', { ns: ['app'] }), //"Portale B2B",
            firstLevelIcon: "icon-calendar",
            hasChildren: true,
            url: RoutePath.B2B,
            ariaLabel: "Portale B2B",
            isExternal: false,
            isRouterLink: false
        }
        const secondLevel:IGlobalMenuSecondLevelCategory[] = [
            {
                secondLevelName: t('sideBar.firstLevelButtons.2.secondLevelButtons.0', { ns: ['app'] }), //"Prenotazioni",
                hasChildren: false,
                isRouterLink: true,
                url: RoutePath.B2B_BOOKINGS_INFO,
            },
            ...(appUserRole !== AppUserRole.ACCESS_STAFF
            ? [{
                secondLevelName: t('sideBar.firstLevelButtons.2.secondLevelButtons.1', { ns: ['app'] }), //"Calendario",
                hasChildren: false,
                isRouterLink: true,
                url: RoutePath.B2B_CALENDAR + "?draft=false"
            }]
            : [])
            /*{
                secondLevelName: t('sideBar.firstLevelButtons.2.secondLevelButtons.1', { ns: ['app'] }), //"Calendario",
                hasChildren: false,
                isRouterLink: true,
                url: RoutePath.B2B_CALENDAR + "?draft=false"
            }*/
        ];

        if(appUserRole===AppUserRole.ADMIN || appUserRole===AppUserRole.SALES_PROFILE || appUserRole===AppUserRole.READER){
            secondLevel.push(
                {
                    secondLevelName: t('sideBar.firstLevelButtons.2.secondLevelButtons.2', { ns: ['app'] }), //"Configurazione",
                    hasChildren: false,
                    isRouterLink: true,
                    url: RoutePath.B2B_CALENDAR_SETTING
                },
                {
                    secondLevelName: t('sideBar.firstLevelButtons.2.secondLevelButtons.3', { ns: ['app'] }), //"Calendario Provvisorio",
                    hasChildren: false,
                    isRouterLink: true,
                    url: RoutePath.B2B_CALENDAR + "?draft=true"
                }
            )
        }
        rootElement.secondLevelCategories = secondLevel;
        return rootElement;
    }

    const getPrebillingMenuItem = ():IGlobalMenuFirstLevelCategory=>{
            const rootElement:IGlobalMenuFirstLevelCategory = {
            firstLevelName: t('sideBar.firstLevelButtons.3', { ns: ['app'] }), //"Pre-Billing",
            firstLevelIcon: "icon-checklist-notes",
            hasChildren: true,
            url: RoutePath.PRE_BILLING_INFO,
            ariaLabel: "Pre billing",
            isExternal: false,
            isRouterLink: true
        }
        const secondLevel:IGlobalMenuSecondLevelCategory[] = [
            {
                secondLevelName: t('sideBar.firstLevelButtons.3', { ns: ['app'] }), //"Pre-Billing",
                hasChildren: false,
                url: RoutePath.PRE_BILLING_INFO,
                ariaLabel: "Pre billing",
                isExternal: false,
                isRouterLink: true
            }
        ];

        if(appUserRole===AppUserRole.ADMIN || appUserRole===AppUserRole.SALES_PROFILE || appUserRole===AppUserRole.PROPERTY_AND_CASUALTY){
            secondLevel.push(
                {
                    secondLevelName: t('sideBar.firstLevelButtons.5.secondLevelButtons.0', { ns: ['app'] }), 
                    hasChildren: false,
                    url: RoutePath.CONGUAGLIO,
                    ariaLabel: "Settlement",
                    isExternal: false,
                    isRouterLink: true
                }
            );
        }
        rootElement.secondLevelCategories = secondLevel;
        return rootElement;
    }
   
    const PRE_BILLING_MENU_ITEM: IGlobalMenuFirstLevelCategory = {
        firstLevelName: t('sideBar.firstLevelButtons.3', { ns: ['app'] }), //"Pre-Billing",
        firstLevelIcon: "icon-checklist-notes",
        hasChildren: false,
        url: RoutePath.PRE_BILLING_INFO,
        ariaLabel: "Pre billing",
        isExternal: false,
        isRouterLink: true
    }


    const SETTINGS_MENU_ITEM: IGlobalMenuFirstLevelCategory = {
        firstLevelName: t('sideBar.firstLevelButtons.4.label', { ns: ['app'] }),// "Impostazioni",
        firstLevelIcon: "icon-setting",
        hasChildren: true,
        url: RoutePath.SETTINGS,
        ariaLabel: "Impostazioni",
        isExternal: false,
        isRouterLink: false,
        secondLevelCategories: [
            {
                secondLevelName: t('sideBar.firstLevelButtons.4.secondLevelButtons.0', { ns: ['app'] }), //"Parametri slot",
                hasChildren: false,
                isRouterLink: true,
                url: RoutePath.SETTINGS_SLOT_PARAMETERS,
            },
            {
                secondLevelName: t('sideBar.firstLevelButtons.4.secondLevelButtons.1', { ns: ['app'] }), //"Freezing date e short term",
                hasChildren: false,
                isRouterLink: true,
                url: RoutePath.SETTINGS_FREEZING_SHORT
            },
            {
                secondLevelName: t('sideBar.firstLevelButtons.4.secondLevelButtons.2', { ns: ['app'] }), //"Freezing date e short term",
                hasChildren: false,
                isRouterLink: true,
                url: RoutePath.SETTINGS_MOVE_PARAMETERS
            },
            {
                secondLevelName: t('sideBar.firstLevelButtons.4.secondLevelButtons.3', { ns: ['app'] }), //"Freezing date e short term",
                hasChildren: false,
                isRouterLink: true,
                url: RoutePath.SETTINGS_SHIPPER_PARAMETERS
            }
        ]
    }

    const appUser: AppUser | undefined = useAppUser();
    const appUserRole: AppUserRole | undefined = appUser?.getRole();
    const appUserProfile: IAppUserProfile | undefined = appUser?.userProfile;

    const getUserMenuItems = (): IGlobalMenuFirstLevelCategory[] => {
        const menuItems: IGlobalMenuFirstLevelCategory[] = [];
        if (appUserProfile?.dashboardMenuItem && appUserRole !== AppUserRole.PROPERTY_AND_CASUALTY&& appUserRole !== AppUserRole.ACCESS_STAFF) {
            menuItems.push(DASHBOARD_MENU_ITEM)
        }
        if (appUserProfile?.contractsMenuItem) {
            menuItems.push(getContractMenuItem());
        }
        if (appUserProfile?.b2bMenuItem) {
            menuItems.push(getB2bMenuItem());
        }
        if (appUserProfile?.prebillingMenuItem) {
            menuItems.push(getPrebillingMenuItem());
        }
        if (appUserProfile?.settingsMenuItem) {
            menuItems.push(SETTINGS_MENU_ITEM);
        }
        return menuItems;
    }




    const SideBarConfigObj: IGlobalMenuConfig = {
        categories: getUserMenuItems()
    }

    //new
    const location = useLocation();
    const validPaths = [
        RoutePath.DASHBOARD, //Aggiunto per il cambio plant, se da problemi toglierlo
        RoutePath.SETTINGS,
        RoutePath.PRE_BILLING_INFO,
        RoutePath.CONTRACTS_CUSTOMER_INFO,
        RoutePath.CONTRACTS_CONTRACT_INFO,
        RoutePath.CONTRACTS_DRIVER_INFO,
        RoutePath.CONTRACTS_TRANSPORTATORS_INFO,
        RoutePath.CONTRACTS_VEHICLE_INFO,
        RoutePath.B2B_BOOKINGS_INFO,
        RoutePath.B2B_CALENDAR,
        RoutePath.B2B_CALENDAR_SETTING,
        RoutePath.B2B_CALENDAR+"?draft=false",
        RoutePath.B2B_CALENDAR+"?draft=true",
        RoutePath.CONGUAGLIO
    ];
    const [activeLink, setActiveLink] = useState<string>(
        validPaths.includes(location.pathname + location.search) 
            ? location.pathname + location.search 
            : RoutePath.DASHBOARD
    );
    useEffect(() => {
        if (!validPaths.includes(location.pathname + location.search)) {
            navigate(RoutePath.DASHBOARD, { replace: true });
        }
    }, []);
    //new

    const [darkTheme, setDarkTheme] = useState<boolean>(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    useEffect(() => {
        navigate(activeLink);
    }, [activeLink, navigate]);

    
    //new
    
    useEffect(() => {
        const currentLocation = location.pathname + location.search;
        if (validPaths.includes(currentLocation as RoutePath)) {
            if (currentLocation !== activeLink) {
                const event = new CustomEvent('linkClick', {
                    detail: { url: currentLocation }
                });
                handleLinkClick(event);
            }
        }
    }, [location.pathname, location.search, activeLink]);

    const handleLinkClick = (event: Event) => {
        
        const path: string = (event as CustomEvent).detail.url;
        setActiveLink(path);
        if (path === window.location.pathname + window.location.search) {
            navigate(path, { replace: true }); 
        } else {
            navigate(path); 
        }
    };
    const sidebarKey = location.pathname;
    //new

    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkScreenSize = () => {
        setIsMobile(window.innerWidth <= 1023); // Cambia la larghezza se necessario
        };
        checkScreenSize(); // Controllo iniziale
        window.addEventListener("resize", checkScreenSize);
        return () => window.removeEventListener("resize", checkScreenSize);
    }, []);

    return (
        <div className="ds-global-navigation ds-global-navigation__sidebar" style={{ 
            zIndex: isMobile ? 4 : 100, 
            position: "fixed", 
            top: isMobile ? "60px" : "24px",
        }}>
            <SidebarDefault
                className="ds-global-menu"
                navigationConfig={SideBarConfigObj}
                activeLink={activeLink}
                navigationAriaLabel={"sidebar menu"}
                key={sidebarKey} //new
                onClickLink={(event: Event) => {
                    //console.log((event as CustomEvent).detail);
                    //let path: string = (event as CustomEvent).detail.url;
                    //setActiveLink(path);
                    handleLinkClick(event) //new
                }}
            ></SidebarDefault>
            <div
                //className="ds-global-navigation__theme-switcher-container ds-dividers ds-dividers--thin ds-dividers--center_solid ds-dividers--horizontal ds-dividers--top"
                className="ds-global-navigation__theme-switcher-container"
                style={{position:'fixed',bottom:0,width:"160px",background:'none'}}
            >
                <p className="ds-global-navigation__theme-label ff-lato-caption-w400">
                    {t('sideBar.themeSwitch', { ns: ['app'] })}
                </p>
                <ThemeSwitcher
                    switchIconLeft="icon-moon"
                    switchIconRight="icon-sun"
                    switchSize="small"
                    checkedButton={darkTheme ? "left" : "right"}
                    buttonLeftAriaLabel="switch to dark theme"
                    buttonRightAriaLabel="switch to light theme"
                    onSwitchChange={(event: Event) => {
                        //console.log(event)
                        const isDark: boolean = (event as CustomEvent).detail.switch === "left";
                        setDarkTheme(isDark ? true : false);
                        dispatch(setLayoutMode(isDark ? DsLayout.DARK_MODE : DsLayout.LIGHT_MODE));
                    }}
                ></ThemeSwitcher>
            </div>
        </div>
    )
}
export default AppSidebar;